import React from 'react';
import { Link } from 'react-router-dom';

const floatingIcons = [
  { src: '/images/cta-icons/ai.png' },
  { src: '/images/cta-icons/clipboard.png' },
  { src: '/images/cta-icons/infinity.png' },
  { src: '/images/cta-icons/globe.png' },
  { src: '/images/cta-icons/briefcase.png' },
  { src: '/images/cta-icons/robot.png' },
  { src: '/images/cta-icons/rocket.png' },
];

export default function CTASection() {
  return (
    <section className="py-16 px-6 lg:px-8">
      <div
        className="mx-auto max-w-6xl rounded-3xl py-20 px-8 relative overflow-hidden"
        style={{
          background: '#F4FBFC',
          boxShadow: '0px 20px 50px rgba(2, 5, 0, 0.08)',
        }}
      >
        <div className="text-center relative z-10">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 rounded-pill bg-cleona-600 px-4 py-2 mb-6">
            <span className="text-white font-manrope font-semibold text-sm">Ready to Build</span>
            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
              <svg className="w-3 h-3 text-cleona-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </span>
          </div>

          {/* Heading */}
          <h2 className="font-jakarta text-4xl font-bold text-gray-900 sm:text-5xl mb-6">
            Ready to Build Your First<br />Smart Assistant™?
          </h2>

          {/* Subtext */}
          <p className="text-gray-600 font-manrope text-lg max-w-2xl mx-auto mb-10">
            Join organizations already using CLEONA to make their information clear, accessible, and always available.
          </p>

          {/* CTA Button */}
          <Link
            to="/admin/signup"
            className="inline-flex items-center gap-2 rounded-pill bg-cleona-600 px-8 py-4 text-lg font-semibold text-white hover:bg-cleona-700 transition-colors font-manrope shadow-lg hover:shadow-xl"
          >
            Start Building
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </div>

        {/* Semi-circle of icons below the button */}
        <div className="relative mt-12 h-64 md:h-80 lg:h-96 w-full mx-auto flex justify-center">
          <div className="relative w-full max-w-5xl">
            {floatingIcons.map((item, index) => {
              // Evenly space icons across the width with a slight arc
              const totalIcons = floatingIcons.length;
              const spacing = 100 / (totalIcons + 1); // even spacing as percentage
              const leftPercent = spacing * (index + 1);

              // Create arc effect - middle icons lower, edge icons higher
              const centerIndex = (totalIcons - 1) / 2;
              const distanceFromCenter = Math.abs(index - centerIndex);
              const maxDistance = centerIndex;
              const arcHeight = (1 - (distanceFromCenter / maxDistance)) * 80; // max 80px drop for center

              return (
                <div
                  key={index}
                  className="absolute"
                  style={{
                    left: `${leftPercent}%`,
                    top: `${arcHeight}px`,
                    transform: 'translateX(-50%)',
                  }}
                >
                <img
                  src={item.src}
                  alt=""
                  className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 animate-bounce-slow"
                  style={{
                    animationDelay: `${index * 0.15}s`,
                    animationDuration: `${2.5 + index * 0.2}s`
                  }}
                />
              </div>
              );
            })}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-bounce-slow {
          animation: bounce-slow 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
